export const isValidEmail = (email: string) => {
  const regex = /@cromai\.com$/
  return regex.test(email)
}
